import { NCloodUser } from '../../providers/contact-manager/contact-manager.service';

export const getNameFromNCloodUser = (nCloodUser: NCloodUser): any => {
    if ( !nCloodUser ) {
        return null;
    }
    return (nCloodUser.contact && nCloodUser.contact.displayName) || (nCloodUser.metadata && nCloodUser.metadata.profileName) || nCloodUser.ncId;
};
